<div
    class="container"
    [ngClass]="{
        'padding-top':inPage && !inGamePage,
        'padding-top-in-game': needInGamePadding(splitScreenService.gridView$ | async),
        'in-game': inGamePage && (splitScreenService.gridView$ | async) && (splitScreenService.gameListLength$ | async) > 1,
        'in-game-off-set-max' : inGamePage && (splitScreenService.gridView$ | async) && needOffSet(splitScreenService.gamesList$ | async) === 'max',
        'in-game-off-set-edge' : inGamePage && (splitScreenService.gridView$ | async) && needOffSet(splitScreenService.gamesList$ | async) === 'edge',
        'game-box-active': (needSpaceForGameBox$ | async),
        'padding-top-grid-view' : splitScreenService.gridView$ | async,
        'club-controls-form': clubControlsForm,
    }"
    [ngStyle]="getBackgroundStyle(background$ | async)"
>
    <div *ngIf="!inGamePage" class="title-container" >
        <div class="left-side">
            <div class="chat-title">Club Chat</div>
            <img src="../../../../assets/icon/chat.png" alt="" class="chat-icon">
        </div>
        <div class="right-side">
            <app-notifications-toggle [isBell]="false"></app-notifications-toggle>
        </div>
    </div>
    <div class="message-box-input-wrapper" [class.in-game]="inGamePage">
        <div class="messages-box scrollable" #scrollMe>
            <app-message-bubble
                *ngFor="let message of messages; trackBy: trackById"
                [message]="message"
                [fromMe]="message.senderID === myId"
                [showAvatar$]="showAvatar$"
            ></app-message-bubble>
            <div
                class="load-more ion-activatable"
                (click)="loadMoreMessage()"
                *ngIf="messages.length > 0 && messages.length == initialMessagesCount">
                    <ion-icon name="chevron-up-outline"></ion-icon>
                    LOAD MORE
                    <ion-ripple-effect></ion-ripple-effect>
            </div>
            <div
                *ngIf="newMessageOnScroll"
                class="scroll-to-bottom-btn clickable"
                (click)="scrollToBottom()"
            >
                <span></span>
                <span></span>
                <span></span>
            </div>
        </div>
        <div class="input-box">
            <ion-input
                autofocus="true"
                type="text"
                placeholder="Type..."
                [(ngModel)]="messageInput"
                (keydown.enter)="sendMessage()"
                class="remove-highlight-on-input">
            </ion-input>
            <div class="button send ion-activatable clickable" (click)="sendMessage()">
                <div title="Send message" id="send-message">
                    <ion-icon class="clickable" name="arrow-up-circle"></ion-icon>
                </div>
                <ion-ripple-effect></ion-ripple-effect>
            </div>
        </div>
    </div>
</div>
